import CloseIcon from '../../../assets/icons/close.svg?react';
import Selector from '../../../components/Selector';
import { useMemo, useState, useEffect } from 'react';
import { useCreateSetUp } from '../../../hooks/queries/setUpQueries';
const SystemSetUpAppendModal = ({ groupNames, onClose }) => {
  const [group, setGroup] = useState(null);
  const groupOptions = useMemo(() => {
    return groupNames.map((groupName) => ({
      id: groupName,
      label: groupName,
      data: groupName,
    }));
  }, [groupNames]);
  const [formData, setFormData] = useState({
    group: null,
    key: null,
    valueType: null,
    description: null,
  });
  const createSetUp = useCreateSetUp();
  const handleFormDataChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }
  const handleGroupChange = (selectedGroup) => {
    // Selector의 value prop에는 전체 객체를 전달해야 함
    setGroup(selectedGroup);
  }
  const [isPending, setIsPending] = useState(false);
  const handleSystemSetUpAppend = async() => {
    try {
      setIsPending(true);
      await createSetUp.mutateAsync({
        group: formData.group,
        key: formData.key,
        valueType: formData.valueType,
        description: formData.description,
      });
      onClose();
    } catch (error) {
      console.error('시스템 설정 추가 실패:', error);
      alert('시스템 설정 추가에 실패했습니다.');
    }
    finally {
      setIsPending(false);
    }
  }
  useEffect(() => {
    if (group) {
      setFormData({ ...formData, group: group.label });
    }
  }, [group]);
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>시스템 설정 추가</h3>
          <button className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>
              <td>
                <label htmlFor="key" className='w-20 mr-10 text-b2-400 text-gray-800'>그룹</label>
              </td>
              <td>
              <Selector id="group" options={groupOptions} placeholder="그룹을 선택하거나 입력하여 새로 만들어주세요."  mode="local" value={group} onChange={handleGroupChange} creatable={true} createLabel="새로 만들기: {검색어}" />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="key" className='w-20 mr-10 text-b2-400 text-gray-800'>키</label>
              </td>
              <td>
                <input type="text" id="key" name="key" className='w-full input-primary' placeholder='키를 입력해주세요.' onChange={handleFormDataChange} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="valueType" className='w-20 mr-10 text-b2-400 text-gray-800'>값 타입</label>
              </td>
              <td>
                <input type="text" id="valueType" name="valueType" className='w-full input-primary' placeholder='값 타입을 입력해주세요.' onChange={handleFormDataChange} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="description" className='w-20 mr-10 text-b2-400 text-gray-800'>설명</label>
              </td>
              <td>
                <input type="text" id="description" name="description" className='w-full input-primary' placeholder='설명을 입력해주세요.' onChange={handleFormDataChange} />
              </td>
            </tr>
          </table>
          <div className='flex w-full mt-20'>
            <button className='btn big-btn btn-primary flex-1' onClick={handleSystemSetUpAppend} disabled={ isPending || !formData.group || !formData.key || !formData.valueType || !formData.description}>{isPending ? '추가 중...' : '추가'}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SystemSetUpAppendModal